import React, { useState, useEffect } from "react";

function Heading({ data, isChild }) {
  const [element, setElement] = useState({
    type: "paragraph",
    properties: {
      title: "",
    },
  });

  useEffect(() => {
    setElement(data);
    // if(isChild){
    //   let obj = { ...data };
    //   obj.properties.required = true;
    //   setElement(data);
    //   if (isChild) {
    //     setElement(obj);
    //   }
    // }
  }, [data]);

  return (
    <div className="form-builder-element" data={JSON.stringify(element)}>
      <p>{element.properties.title}</p>
    </div>
  );
}

export default Heading;
